import { render, staticRenderFns } from "./SchoolStep.vue?vue&type=template&id=4d0011a5&scoped=true&"
import script from "./SchoolStep.vue?vue&type=script&lang=js&"
export * from "./SchoolStep.vue?vue&type=script&lang=js&"
import style0 from "./SchoolStep.vue?vue&type=style&index=0&id=4d0011a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0011a5",
  null
  
)

export default component.exports